import request from '../utils/request'

const prefix = '/api/v1/back'

/**
 * 用户&学长部分
 *
 */

/**
 * 学长申请查询：列表
 * @param {*} query
 */
export const seniorApplyList = (query) => {
  return request({
    url: `${prefix}/senior/apply/list`,
    method: 'get',
    params: query
  })
}

/**
 * 学长查询
 * @param {*} query
 */
export const seniorApplyOne = (query) => {
  return request({
    url: `${prefix}/senior/apply`,
    method: 'get',
    params: query
  })
}

/**
 * 学长申请 信息修改
 * @param {*} query
 */
export const editSeniorApply = (query) => {
  return request({
    url: `${prefix}/senior/apply`,
    method: 'put',
    data: query
  })
}

/**
 * 学长申请审核 通过
 * @param {*} query
 */
export const seniorApplyApprove = (query) => {
  return request({
    url: `${prefix}/senior/apply/approve`,
    method: 'put',
    data: query
  })
}

/**
 * 学长申请审核 驳回
 * @param {*} query
 */
export const seniorApplyReject = (query) => {
  return request({
    url: `${prefix}/senior/apply/reject`,
    method: 'put',
    data: query
  })
}

/**
 * 学长申请审核 删除
 * @param {*} query
 */
export const seniorApplyDelete = (query) => {
  return request({
    url: `${prefix}/senior/apply`,
    method: 'delete',
    data: query
  })
}

/**
 * 学长查询：列表
 * @param {*} query
 */
export const seniorList = (query) => {
  return request({
    url: `${prefix}/senior/list`,
    method: 'get',
    params: query
  })
}

/**
 * 学长查询
 * @param {*} query
 */
export const seniorOne = (query) => {
  return request({
    url: `${prefix}/senior`,
    method: 'get',
    params: query
  })
}
/**
 * 学长评论审核
 * @param {*} query
 */
export const commentCheck = (query) => {
  return request({
    url: `${prefix}/note/comment/check`,
   method: 'post',
    data: query
  })
}

/**
 * 学长创建
 * @param {*} query
 */
export const seniorCreate = (query) => {
  return request({
    url: `${prefix}/senior`,
    method: 'post',
    data: query
  })
}

/**
 * 学长修改
 * @param {*} query
 */
export const seniorUpdate = (query) => {
  return request({
    url: `${prefix}/senior`,
    method: 'put',
    data: query
  })
}

/**
 * 学长状态修改
 * @param {*} query
 */
export const seniorUpdateStatus = (query) => {
  return request({
    url: `${prefix}/senior/status`,
    method: 'put',
    data: query
  })
}

/**
 * 学长删除
 * @param {*} query
 */
export const seniorDestroy = (query) => {
  return request({
    url: `${prefix}/senior`,
    method: 'delete',
    data: query
  })
}

/**
 * 学长删除：列表
 * @param {*} query
 */
export const seniorRemoves = (query) => {
  return request({
    url: `${prefix}/senior/list`,
    method: 'delete',
    data: query
  })
}

/**
 * 学长订单查询 列表
 * @param {*} query
 */
export const seniorOrderList = (query) => {
  return request({
    url: `${prefix}/senior/order/list`,
    method: 'get',
    params: query
  })
}

/**
 * 学长订单查询 单条
 * @param {*} query
 */
export const seniorOrderOne = (query) => {
  return request({
    url: `${prefix}/senior/order`,
    method: 'get',
    params: query
  })
}

/**
 * 学长营收记录查询 列表分页
 * @param {*} query
 */
export const seniorProfitLogs = (query) => {
  return request({
    url: `${prefix}/senior/profit/logs`,
    method: 'get',
    params: query
  })
}

/**
 * 学长提现订单创建
 * @param {*} query
 */
export const seniorWithdrawCreate = (query) => {
  return request({
    url: `${prefix}/senior/withdraw/order`,
    method: 'post',
    data: query
  })
}

/**
 * 学长提现订单撤销
 * @param {*} query
 */
export const seniorWithdrawRevoke = (query) => {
  return request({
    url: `${prefix}/senior/withdraw/revoke`,
    method: 'post',
    data: query
  })
}

/**
 * 学长提现订单查询
 * @param {*} query
 */
export const seniorWithdrawOne = (query) => {
  return request({
    url: `${prefix}/senior/withdraw/order`,
    method: 'get',
    params: query
  })
}

/**
 * 学长提现订单查询 列表
 * @param {*} query
 */
export const seniorWithdrawList = (query) => {
  return request({
    url: `${prefix}/senior/withdraw/order/list`,
    method: 'get',
    params: query
  })
}

/**
 * 学长预约查询 列表
 * @param {*} query
 */
export const seniorBookingList = (query) => {
  return request({
    url: `${prefix}/senior/booking/list`,
    method: 'get',
    params: query
  })
}

/**
 * 学长预约更改
 * @param {*} query
 */
export const seniorBookingUpdate = (query) => {
  return request({
    url: `${prefix}/senior/booking`,
    method: 'put',
    data: query
  })
}


/**
 * 作者返佣订单（查询列表）
 * @param {*} query
 */
export const authorOrderlist = (query) => {
  return request({
    url: `${prefix}/senior/referrer/authorOrder/list`,
    method: 'get',
    params: query
  })
}
/**
 * 学长订单（查询列表）
 * @param {*} query
 */

export const memberOrderlist = (query) => {
  return request({
    url: `${prefix}/member/order/list`,
    method: 'get',
    params: query
  })
}
/**
 * 学长问题查询（查询列表）
 * @param {*} query
 */
export const questionList = (query) => {
  return request({
    url: `${prefix}/senior/qaPaper/userAnswer/list`,
    method: 'get',
    params: query
  })
}
/**
 * 学长问题详情（详情）
 * @param {*} query
 */
export const userAnswerDetail = (query) => {
  return request({
    url: `${prefix}/senior/qaPaper/userAnswer`,
    method: 'get',
    params: query
  })
}

/**
 * 学长问题列表（问题列表）
 * @param {*} query
 */
export const questionDetail = (query) => {
  return request({
    url: `${prefix}/senior/qaPaper/question`,
    method: 'get',
    params: query
  })
}
/**
 * 学长问题创建（问题创建）
 * @param {*} query
 */
export const userAnswerCreated = (query) => {
  return request({
    url: `${prefix}/senior/qaPaper/userAnswer`,
    method: 'post',
    data: query
  })
}
/**
 * 学长问题删除（问题删除）
 * @param {*} query
 */
export const questionRemoves = (query) => {
  return request({
    url: `${prefix}/senior/qaPaper/userAnswer`,
    method: 'delete',
    data: query
  })
}

/**
 * 学长问题上下架修改（上下架）
 * @param {*} query
 */
export const questionPut= (query) => {
  return request({
    url: `${prefix}/senior/qaPaper/userAnswer`,
    method: 'put',
    data: query
  })
}


export const check = (query) => {
  return request({
    url: `${prefix}/senior/qaPaper/userAnswer/check`,
    method: 'post',
    data: query
  })
}

/**
 * 获取所有的问题列表
 * @param {*} query
 */
export const list = (query) => {
  return request({
    url: `${prefix}/senior/qaPaper/question/list`,
    method: 'get',
    params: query
  })
}

/**
 * 学长沟通列表
 * @param {*} query
 */
export const chatList = (query) => {
  return request({
    url: `${prefix}/senior/chat/list`,
    method: 'get',
    params: query
  })
}
/**
 * 学长消息列表
 * @param {*} query
 */
export const messageList = (query) => {
  return request({
    url: `${prefix}/senior/chat/message/list`,
    method: 'get',
    params: query
  })
}
/**
 * 学长打招呼语
 * @param {*} query
 */
export const sendMessage = (query) => {
  return request({
    url: `${prefix}/senior/chat/sendMessage`,
    method: 'post',
    data: query
  })
}
/**
 * 批量修改解锁时间接口
 * @param {*} query
 */
export const unlockTimeList = (query) => {
  return request({
    url: `${prefix}/senior/chat/unlockTime/list`,
    method: 'put',
    data: query
  })
}

/**
 * 消息隐藏接口
 * @param {*} query
 */
export const messageHide = (query) => {
  return request({
    url: `${prefix}/senior/chat/message/hide`,
    method: 'post',
    data: query
  })
}
/**
 * 消息取消隐藏接口
 * @param {*} query
 */

export const hideCancel = (query) => {
  return request({
    url: `${prefix}/senior/chat/message/hideCancel`,
    method: 'post',
    data: query
  })
}

/**
 * 学长聊天删除
 * @param {*} query
 */

export const chatCancel = (query) => {
  return request({
    url: `${prefix}/senior/chat`,
    method: 'delete',
    data: query
  })
}
/**
 * 用户禁言
 * @param {*} query
 */
export const chatUserExtend = (query) => {
  return request({
    url: `${prefix}/senior/chat/user/chatUserExtend`,
    method: 'put',
    data: query
  })
}
/**
 * 查询关键词列表
 * @param {*} query
 */

export const keyworNotifyList = (query) => {
  return request({
    url: `${prefix}/senior/chat/user/keyworNotify/list`,
    method: 'get',
    params: query
  })
}

/**
 * 创建关键词
 * @param {*} query
 */
export const addkeyworNotify = (query) => {
  return request({
    url: `${prefix}/senior/chat/user/keyworNotify`,
    method: 'post',
    data: query
  })
}
/**
 * 编辑关键词
 * @param {*} query
 */
export const editkeyworNotify = (query) => {
  return request({
    url: `${prefix}/senior/chat/user/keyworNotify`,
    method: 'put',
    data: query
  })
}
/**
 * 删除关键词
 * @param {*} query
 */
export const detekeyworNotify = (query) => {
  return request({
    url: `${prefix}/senior/chat/user/keyworNotify/list`,
    method: 'delete',
    data: query
  })
}
/**
 * 查询敏感词列表
 * @param {*} query
 */

export const SensiitivList = (query) => {
  return request({
    url: `${prefix}/sysSensiitiveWord/inner/list`,
    method: 'get',
    params: query
  })
}
/**
 * 新增敏感词列表
 * @param {*} query
 */
export const addSensiitive = (query) => {
  return request({
    url: `${prefix}/sysSensiitiveWord/inner`,
    method: 'post',
    data: query
  })
}
/**
 * 删除敏感词
 * @param {*} query
 */
export const deleteSensitive = (query) => {
  return request({
    url: `${prefix}/sysSensiitiveWord/inner/list`,
    method: 'delete',
    data: query
  })
}
 
/**
 * 学长聊天服务人推荐开关设置接口 
 * @param {*} query
 */
export const autoRecommedStatus = (query) => {
  return request({
    url: `${prefix}/senior/chat/servicer/autoRecommedStatus`,
    method: 'put',
    data: query
  })
}
/**
 * 增加学长服务标签类型
 * @param {*} query
 */
export const addTag = (query) => {
  return request({
    url: `${prefix}/senior/chat/servicer/tag`,
    method: 'post',
    data: query
  })
}

/**
 * 学长服务标签删除
 * @param {*} query
 */
export const deletetag= (query) => {
  return request({
    url: `${prefix}/senior/chat/servicer/tag`,
    method: 'delete',
    data: query
  })
}
/**
 * 学长经验评论列表
 * @param {*} query
 */
export const commentList = (query) => {
  return request({
    url: `${prefix}/article/comment/list`,
    method: 'get',
    params: query
  })
}

/**
 * 学长经验评论删除
 * @param {*} query
 */
export const deleteComment= (query) => {
  return request({
    url: `${prefix}/article/comment/list`,
    method: 'delete',
    data: query
  })
}
/**
 * 获取学长经验一级评论
 * @param {*} query
 */

export const levelOneList= (query) => {
  return request({
    url: `${prefix}/article/comment/levelOne/list`,
     method: 'get',
    params: query
  })
}
/**
 * 获取学长经验二级评论
 * @param {*} query
 */

export const twoList= (query) => {
  return request({
    url: `${prefix}/article/comment/levelTwo/list`,
     method: 'get',
    params: query
  })
}
/**
 * 笔记列表
 * @param {*} query
 */

export const noteList= (query) => {
  return request({
    url: `${prefix}/note/list`,
     method: 'get',
    params: query
  })
}
/**
 * 笔记审核
 * @param {*} query
 */
export const noteAuite= (query) => {
  return request({
    url: `${prefix}/note/check/list`,
     method: 'post',
    data: query
  })
}
/**
 * 笔记详情接口
 * @param {*} query
 */
export const noteDetail= (query) => {
  return request({
    url: `${prefix}/note`,
     method: 'get',
    params: query
  })
}
/**
 * 笔记修改接口
 * @param {*} query
 */

export const  notePut = (query) => {
  return request({
    url: `${prefix}/note`,
    method: 'put',
    data: query
  })
}
/**
 * 笔记删除接口
 * @param {*} query
 */

export const  noteDelete = (query) => {
  return request({
    url: `${prefix}/note/list`,
     method: 'delete',
    data: query
  })
}
/**
 * 笔记一级评论
 * @param {*} query
 */

export const noteOneList= (query) => {
  return request({
    url: `${prefix}/note/comment/levelOne/list`,
     method: 'get',
    params: query
  })
}
/**
 * 笔记二级评论
 * @param {*} query
 */

export const noteTwoList= (query) => {
  return request({
    url: `${prefix}/note/comment/levelTwo/list`,
     method: 'get',
    params: query
  })
}

/**
 * 评论删除接口
 * @param {*} query
 */

export const  noteCommentDelete = (query) => {
  return request({
    url: `${prefix}/note/comment/list`,
     method: 'delete',
    data: query
  })
}
/**
 * 笔记评论列表
 * @param {*} query
 */

export const noteAdminList= (query) => {
  return request({
    url: `${prefix}/note/comment/list`,
     method: 'get',
    params: query
  })
}
/**
 * 分享统计
 * @param {*} query
 */

export const shareLogList= (query) => {
  return request({
    url: `${prefix}/shareLog/list`,
     method: 'get',
    params: query
  })
}
/**
 * 分享行为记录
 * @param {*} query
 */

export const shareBehaveLogList= (query) => {
  return request({
    url: `${prefix}/shareBehaveLog/list`,
     method: 'get',
    params: query
  })
}
/**
 * 笔记用户管理
 * @param {*} query
 */
export const noteUserList= (query) => {
  return request({
    url: `${prefix}/note/user/list`,
     method: 'get',
    params: query
  })
}
/**
 * 笔记用户批量删除
 * @param {*} query
 */
export const noteUserDelete= (query) => {
  return request({
    url: `${prefix}/note/user/list`,
     method: 'DELETE',
    data: query
  })
}

/**
 * 笔记用户封禁
 * @param {*} query
 */
export const noteUserForite= (query) => {
  return request({
    url: `${prefix}/note/user`,
     method: 'put',
    data: query
  })
}
/**
 * 积分明细列表
 * @param {*} query
 */
export const  integralList= (query) => {
  return request({
    url: `${prefix}/member/integral/log/list`,
     method: 'get',
    params: query
  })
}
/**
 * 学长信息详情
 * @param {*} query
 */
export const  seniorDetail= (query) => {
  return request({
    url: `${prefix}/senior`,
     method: 'get',
    params: query
  })
}

/**
 * 评论创建
 * @param {*} query
 */

export const  commentCrtaed= (query) => {
  return request({
       url: `${prefix}/note/comment`,
       method: 'post',
       data: query
  })
}
/**
 * 评论修改
 * @param {*} query
 */
export const commentPut= (query) => {
  return request({
     url: `${prefix}/note/comment`,
     method: 'put',
    data: query
  })
}

/**
 * 获取所有看法/note/opinion/list
 * @param {*} query
 */
export const  opinionList= (query) => {
  return request({
    url: `${prefix}/senior/qaPaper/question/list`,
     method: 'get',
    params: query
  })
}
/**
 * 新建看法/note/opinion
 * @param {*} query
 */
export const  createOption= (query) => {
  return request({
    url: `${prefix}/senior/qaPaper/question`,
    method: 'post',
       data: query
  })
}
/**
 *修改看法
 * @param {*} query
 */
export const  putOption= (query) => {
  return request({
    url: `${prefix}/senior/qaPaper/question`,
    method: 'put',
       data: query
  })
}

/**
 *删除看法
 * @param {*} query
 */
export const  cancleOption= (query) => {
  return request({
    url: `${prefix}/senior/qaPaper/question`,
     method: 'DELETE',
    data: query
  })
}
/**
 *笔记用户修改
 * @param {*} query
 */

export const  putNoteUser= (query) => {
  return request({
    url: `${prefix}/note/user`,
    method: 'put',
       data: query
  })
}



/**
 *笔记虚拟用户创建
 * @param {*} query
 */

export const  createUserIdentity= (query) => {
  return request({
    url: `${prefix}/note/userIdentity`,
    method: 'post',
       data: query
  })
}
/**
 *笔记虚拟用户编辑
 * @param {*} query
 */
export const  putUserIdentity= (query) => {
  return request({
    url: `${prefix}/note/userIdentity`,
    method: 'put',
       data: query
  })
}
/**
 *笔记虚拟用户删除
 * @param {*} query
 */
 export const  deleteUserIdentity= (query) => {
  return request({
    url: `${prefix}/note/userIdentity`,
    method: 'delete',
      data: query
  })
}

/**
 *笔记虚拟用户获取随机头像
 * @param {*} query
 */
 export const  generateRandomAvatar= (query) => {
  return request({
    url: `${prefix}/note/userIdentity/generateRandomAvatar`,
    method: 'get',
    params: query
  })
}
/**
 *学长营收记录请求
 * @param {*} query
 */
 export const  profitlogsList= (query) => {
  return request({
    url: `${prefix}/member/profit/logs`,
    method: 'get',
    params: query
  })
}
/**
 *系统发送消息
 * @param {*} query
 */

 export const  sendMessages= (query) => {
  return request({
    url: `${prefix}/senior/chat/sys/sendMessage`,
     method: 'post',
       data: query
  })
}
/**
 *专题列表
 * @param {*} query
 */
export const  themePageList= (query) => {
  return request({
    url: `${prefix}/themePage/list`,
    method: 'get',
    params: query
  })
}

/**
 * 专题页 删除
 * @param {*} query
 */
export const themePageDelete = (query) => {
  return request({
    url: `${prefix}/themePage/list`,
    method: 'delete',
    data: query
  })
}
/**
 * 专题页 创建
 * @param {*} query
 */
export const  themePageCreate= (query) => {
  return request({
    url: `${prefix}/themePage`,
    method: 'post',
       data: query
  })
}
/**
 * 专题页  详情
 * @param {*} query
 */
export const  themePageDetail= (query) => {
  return request({
    url: `${prefix}/themePage`,
     method: 'get',
    params: query
  })
}

/**
 * 专题页  修改
 * @param {*} query
 */
export const  themePagePut= (query) => {
  return request({
    url: `${prefix}/themePage`,
     method: 'put',
       data: query
  })
}

/**
 * 专题分类创建
 * @param {*} query
 */
export const  themeType= (query) => {
  return request({
    url: `${prefix}/themePage/seniorCategory`,
     method: 'post',
       data: query
  })
}

/**
 * 获取分类列表
 * @param {*} query
 */

export const  categoryDetail= (query) => {
  return request({
    url: `${prefix}/themePage/seniorCategory/list`,
     method: 'get',
    params: query
  })
}

/**
 * 获取分类详情
 * @param {*} query
 */
export const  seniorCategoryDetail= (query) => {
  return request({
    url: `${prefix}/themePage/seniorCategory`,
     method: 'get',
    params: query
  })
}
/**
 * 获取分类编辑
 * @param {*} query
 */
export const  seniorCategoryPut= (query) => {
  return request({
    url: `${prefix}/themePage/seniorCategory`,
     method: 'put',
    data: query
  })
}

/**
 * 问题与反馈列表
 * @param {*} query
 */
export const  feedbackList= (query) => {
  return request({
    url: `${prefix}/question/feedback/list`,
     method: 'get',
    params: query
  })
}

/**
 * 问题与反馈
 * @param {*} query
 */
export const  feedbackDelte= (query) => {
  return request({
    url: `${prefix}/question/feedback/list`,
     method: 'delete',
    data: query
  })
}

/**
 * 问题与反馈详情
 * @param {*} query
 */
export const  feedbackDetail= (query) => {
  return request({
    url: `${prefix}/question/feedback`,
     method: 'get',
    params: query
  })
}

/**
 * 问题与反馈修改
 * @param {*} query
 */
export const  feedbackPut= (query) => {
  return request({
    url: `${prefix}/question/feedback`,
      method: 'put',
    data: query
  })
}













 





